// @ts-nocheck

import * as Apollo from "@apollo/client";

import gql from "graphql-tag";
import * as APITypes from "../../apiTypes";

const defaultOptions = {} as const;
export type LoginAuthenticateUserMutationVariables = APITypes.Exact<{
  phone_number: APITypes.Scalars["String"]["input"];
  code: APITypes.Scalars["String"]["input"];
}>;

export type LoginAuthenticateUserMutation = {
  solveLoginChallenge: { access_token: string; refresh_token: string };
};

export type AuthenticateWithFacebookMutationVariables = APITypes.Exact<{
  data: APITypes.AuthenticateWithSocialMediaInput;
}>;

export type AuthenticateWithFacebookMutation = {
  authenticateWithFacebook: { access_token: string; refresh_token: string };
};

export type AuthenticateWithGoogleMutationVariables = APITypes.Exact<{
  data: APITypes.AuthenticateWithSocialMediaInput;
}>;

export type AuthenticateWithGoogleMutation = {
  authenticateWithGoogle: { access_token: string; refresh_token: string };
};

export type RefreshTokenMutationVariables = APITypes.Exact<{
  refresh_token: APITypes.Scalars["String"]["input"];
}>;

export type RefreshTokenMutation = { refreshToken: string };

export type GetCurrentAppVersionQueryVariables = APITypes.Exact<{
  appType: APITypes.AppTypeEnum;
}>;

export type GetCurrentAppVersionQuery = {
  getCurrentAppVersion: {
    androidVersion: string;
    appType: APITypes.AppTypeEnum;
    iosVersion: string;
    webVersion: string;
  };
};

export const LoginAuthenticateUserDocument = gql`
    mutation LoginAuthenticateUser($phone_number: String!, $code: String!) {
  solveLoginChallenge(data: {phone_number: $phone_number, code: $code}) {
    access_token
    refresh_token
  }
}
    `;
export type LoginAuthenticateUserMutationFn = Apollo.MutationFunction<
  LoginAuthenticateUserMutation,
  LoginAuthenticateUserMutationVariables
>;

/**
 * __useLoginAuthenticateUserMutation__
 *
 * To run a mutation, you first call `useLoginAuthenticateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginAuthenticateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginAuthenticateUserMutation, { data, loading, error }] = useLoginAuthenticateUserMutation({
 *   variables: {
 *      phone_number: // value for 'phone_number'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useLoginAuthenticateUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LoginAuthenticateUserMutation,
    LoginAuthenticateUserMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<LoginAuthenticateUserMutation, LoginAuthenticateUserMutationVariables>(
    LoginAuthenticateUserDocument,
    options,
  );
}
export type LoginAuthenticateUserMutationHookResult = ReturnType<
  typeof useLoginAuthenticateUserMutation
>;
export type LoginAuthenticateUserMutationResult =
  Apollo.MutationResult<LoginAuthenticateUserMutation>;
export type LoginAuthenticateUserMutationOptions = Apollo.BaseMutationOptions<
  LoginAuthenticateUserMutation,
  LoginAuthenticateUserMutationVariables
>;
export const AuthenticateWithFacebookDocument = gql`
    mutation AuthenticateWithFacebook($data: AuthenticateWithSocialMediaInput!) {
  authenticateWithFacebook(data: $data) {
    access_token
    refresh_token
  }
}
    `;
export type AuthenticateWithFacebookMutationFn = Apollo.MutationFunction<
  AuthenticateWithFacebookMutation,
  AuthenticateWithFacebookMutationVariables
>;

/**
 * __useAuthenticateWithFacebookMutation__
 *
 * To run a mutation, you first call `useAuthenticateWithFacebookMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateWithFacebookMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateWithFacebookMutation, { data, loading, error }] = useAuthenticateWithFacebookMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAuthenticateWithFacebookMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AuthenticateWithFacebookMutation,
    AuthenticateWithFacebookMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AuthenticateWithFacebookMutation,
    AuthenticateWithFacebookMutationVariables
  >(AuthenticateWithFacebookDocument, options);
}
export type AuthenticateWithFacebookMutationHookResult = ReturnType<
  typeof useAuthenticateWithFacebookMutation
>;
export type AuthenticateWithFacebookMutationResult =
  Apollo.MutationResult<AuthenticateWithFacebookMutation>;
export type AuthenticateWithFacebookMutationOptions = Apollo.BaseMutationOptions<
  AuthenticateWithFacebookMutation,
  AuthenticateWithFacebookMutationVariables
>;
export const AuthenticateWithGoogleDocument = gql`
    mutation AuthenticateWithGoogle($data: AuthenticateWithSocialMediaInput!) {
  authenticateWithGoogle(data: $data) {
    access_token
    refresh_token
  }
}
    `;
export type AuthenticateWithGoogleMutationFn = Apollo.MutationFunction<
  AuthenticateWithGoogleMutation,
  AuthenticateWithGoogleMutationVariables
>;

/**
 * __useAuthenticateWithGoogleMutation__
 *
 * To run a mutation, you first call `useAuthenticateWithGoogleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateWithGoogleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateWithGoogleMutation, { data, loading, error }] = useAuthenticateWithGoogleMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useAuthenticateWithGoogleMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AuthenticateWithGoogleMutation,
    AuthenticateWithGoogleMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AuthenticateWithGoogleMutation,
    AuthenticateWithGoogleMutationVariables
  >(AuthenticateWithGoogleDocument, options);
}
export type AuthenticateWithGoogleMutationHookResult = ReturnType<
  typeof useAuthenticateWithGoogleMutation
>;
export type AuthenticateWithGoogleMutationResult =
  Apollo.MutationResult<AuthenticateWithGoogleMutation>;
export type AuthenticateWithGoogleMutationOptions = Apollo.BaseMutationOptions<
  AuthenticateWithGoogleMutation,
  AuthenticateWithGoogleMutationVariables
>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($refresh_token: String!) {
  refreshToken(refresh_token: $refresh_token)
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<
  RefreshTokenMutation,
  RefreshTokenMutationVariables
>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      refresh_token: // value for 'refresh_token'
 *   },
 * });
 */
export function useRefreshTokenMutation(
  baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(
    RefreshTokenDocument,
    options,
  );
}
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<
  RefreshTokenMutation,
  RefreshTokenMutationVariables
>;
export const GetCurrentAppVersionDocument = gql`
    query GetCurrentAppVersion($appType: AppTypeEnum!) {
  getCurrentAppVersion(appType: $appType) {
    androidVersion
    appType
    iosVersion
    webVersion
  }
}
    `;

/**
 * __useGetCurrentAppVersionQuery__
 *
 * To run a query within a React component, call `useGetCurrentAppVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentAppVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentAppVersionQuery({
 *   variables: {
 *      appType: // value for 'appType'
 *   },
 * });
 */
export function useGetCurrentAppVersionQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCurrentAppVersionQuery,
    GetCurrentAppVersionQueryVariables
  > &
    ({ variables: GetCurrentAppVersionQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCurrentAppVersionQuery, GetCurrentAppVersionQueryVariables>(
    GetCurrentAppVersionDocument,
    options,
  );
}
export function useGetCurrentAppVersionLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCurrentAppVersionQuery,
    GetCurrentAppVersionQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetCurrentAppVersionQuery, GetCurrentAppVersionQueryVariables>(
    GetCurrentAppVersionDocument,
    options,
  );
}
export function useGetCurrentAppVersionSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetCurrentAppVersionQuery,
        GetCurrentAppVersionQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetCurrentAppVersionQuery, GetCurrentAppVersionQueryVariables>(
    GetCurrentAppVersionDocument,
    options,
  );
}
export type GetCurrentAppVersionQueryHookResult = ReturnType<typeof useGetCurrentAppVersionQuery>;
export type GetCurrentAppVersionLazyQueryHookResult = ReturnType<
  typeof useGetCurrentAppVersionLazyQuery
>;
export type GetCurrentAppVersionSuspenseQueryHookResult = ReturnType<
  typeof useGetCurrentAppVersionSuspenseQuery
>;
export type GetCurrentAppVersionQueryResult = Apollo.QueryResult<
  GetCurrentAppVersionQuery,
  GetCurrentAppVersionQueryVariables
>;
